import { Button, Dialog, Stack, Typography } from '@mui/material';
import React from 'react';
import ModalHeader from '../../../../components/ModalHeader';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import { Form, Formik } from 'formik';
import { useRef } from 'react';
import { useTheme } from '@emotion/react';
import * as yup from 'yup';
import FormTextField from '../../../../components/FormTextField';
import { useDispatch, useSelector } from 'react-redux';
import PageHeader from '../../../../components/PageHeader';
import { CheckBox } from '@mui/icons-material';
import { useState } from 'react';
import { CancelToken } from 'apisauce';
import appapi from '../../../../api/apiClient';
import { useEffect } from 'react';
import Datatable from '../../../../components/DataTable';
import { showmessage } from '../../../../utils/toastr';
import { setLoading } from '../../../../redux/features/appSlice';
import { useTranslation } from 'react-i18next';

const validationSchema = yup.object({
  tradeType: yup.string('Trader Type').required(' '),
  priceType: yup.string('Price Type').required(' '),
  euaRequired: yup.string('Eua Required').required(' '),
  remarks: yup.string('Remarks').required(' ').min(3).max(300),
  // traderIds: yup.array().of(yup.string()).min(1).required(),
});

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

export default function RequestForm({ modelOpen, onModelHandleClose, init }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();

  let source = CancelToken.source();

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
    },
    {
      id: 1,
      header: 'Trader',
      accessor: 'traderName',
      width: '40%',
      capitalize: true,
    },
    {
      id: 2,
      header: 'Email',
      accessor: 'email',
      width: '40%',
    },
  ];

  const { user, companyDetails } = useSelector((state) => state.auth);
  const [tradeList, setTradeList] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState(null);
  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);

  const {t} = useTranslation()

  const getTraders = async () => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `trader/traderListForCompany/${user?.companyId}`,
      { filter },
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let arr = data?.response;
        arr.map((item, index) => {
          item.Sno = index + 1;
          item.isSelected = false;
          return item;
        });
        setTradeList(arr);
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTraders();

    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [filter]);

  const handleSearchEmit = (text) => {
    if (text) {
      setFilter(text.trim());
    } else {
      setFilter(text);
    }
  };

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    const companies = [...selectedCompanyIds];
    const ids = companies.map((res) => res._id);
    if (checkedStatus) {
      companies.push(item);
    } else {
      const index = ids.indexOf(item._id);
      if (index != -1) {
        companies.splice(index, 1);
      }
    }
    setSelectedCompanyIds([...companies]);
  };

  useEffect(() => {
    if (selectedCompanyIds.length > 0) {
      const items = tradeList.map((res) => {
        return {
          ...res,
          isSelected: selectedCompanyIds.map((res) => res._id).includes(res._id),
        };
      });
      setIsAllChecked(selectedCompanyIds.length === items.length)
      setTradeList(items);
    } else {
      const items = tradeList.map((res) => {
        return {
          ...res,
          isSelected: false,
        };
      });
      setIsAllChecked(false)
      setTradeList(items);
    }
  }, [selectedCompanyIds]);

  const handleSendQuote = async (values) => {
    dispatch(setLoading(true));
    const payload = {
      traderIds: selectedCompanyIds.map((res) => {
        return res._id;
      }),
      euqRequired: parseInt(values?.euaRequired),
      ...values,
    };
    const response = await appapi.post(`/trader/quoteRequest`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        // className="!h-[100%]"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <ModalHeader
          label={t('REQUEST FORM')}
          onClose={() => onModelHandleClose(false)}
        />
        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
          className=""
        />
        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{
            companyId: user?.companyId,
            companyName: companyDetails?.companyName,
            displayName: companyDetails?.displayName,
            tradeType: 'buy',
            priceType: 'spot',
            euaRequired: '',
            remarks: '',
            // traderIds: selectedTraders,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSendQuote(values);
          }}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue, setFieldTouched }) => (
            <Form
              className="flex flex-col flex-1"
              autoComplete="off"
            >
              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="m-[15px] p-[16px]"
              >
                <Typography
                  className="fw-regular ff-Roboto fs-16 !capitalize"
                  color={text}
                >
                  {t('Trade details')}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                  color={textLight}
                >
                {t('Some info may be visible to other people using ZeroEmission services')}
                </Typography>

                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[8px] !capitalize"
                  color={text}
                >
                  {t('Trade type')}
                </Typography>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  style={{ cursor: 'pointer' }}
                >
                  <Stack
                    style={{ backgroundColor: values?.tradeType === 'buy' ? '#003399' : '#8993AC1A', borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px', width: '104px', height: '40px', alignItems: 'center', justifyContent: 'center' }}
                    onClick={() => setFieldValue('tradeType', 'buy')}
                  >
                    <Typography color={values?.tradeType === 'buy' ? '#FFFFFF' : '#003399'}>{t('buy')}</Typography>
                  </Stack>
                  <Stack
                    style={{ backgroundColor: values?.tradeType === 'sell' ? '#003399' : '#8993AC1A', borderTopRightRadius: '4px', borderBottomRightRadius: '4px', width: '104px', height: '40px', alignItems: 'center', justifyContent: 'center' }}
                    onClick={() => setFieldValue('tradeType', 'sell')}
                  >
                    <Typography color={values?.tradeType === 'sell' ? '#FFFFFF' : '#003399'}>{t('sell')}</Typography>
                  </Stack>
                </Stack>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mt-[18px] !mb-[8px] !capitalize"
                  color={text}
                >
                  {t('Select price type')}
                </Typography>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  className="mb-[18px]"
                  style={{ cursor: 'pointer' }}
                >
                  <Stack
                    style={{ backgroundColor: values?.priceType === 'spot' ? '#003399' : '#8993AC1A', borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px', width: '104px', height: '40px', alignItems: 'center', justifyContent: 'center' }}
                    onClick={() => setFieldValue('priceType', 'spot')}
                  >
                    <Typography color={values?.priceType === 'spot' ? '#FFFFFF' : '#003399'}>{t('spot')}</Typography>
                  </Stack>
                  <Stack
                    style={{ backgroundColor: values?.priceType === 'future' ? '#003399' : '#8993AC1A', borderTopRightRadius: '4px', borderBottomRightRadius: '4px', width: '104px', height: '40px', alignItems: 'center', justifyContent: 'center' }}
                    onClick={() => setFieldValue('priceType', 'future')}
                  >
                    <Typography color={values?.priceType === 'future' ? '#FFFFFF' : '#003399'}>{t('future')}</Typography>
                  </Stack>
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('EUA Quantity')}
                    name="euaRequired"
                    requiredMark={true}
                    onlyNumber={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 10 }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Remark')}
                    name="remarks"
                    multiline={true}
                    maxRows={3}
                    requiredMark={true}
                    inputProps={{ maxLength: 301 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        minHeight: '88px !important',
                        display: 'block',
                      },
                    }}
                  />
                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="m-[15px]"
              >
                <PageHeader
                  tableType={'2'}
                  headerColor={'#006DFF0D'}
                  showCloseBtn={true}
                  //   handleClose={handleClose}
                  handleOnSearchEmit={(search) => {
                    handleSearchEmit(search);
                  }}
                >
                  <Stack direction="row">
                    <Stack style={{ paddingLeft: '10px' }}>
                      <Typography
                        className="fs-16 ff-Roboto fw-regular !capitalize"
                        color={'#14285A'}
                      >
                        {t('Add traders')}
                      </Typography>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular"
                        color={'#8993AC'}
                      >
                        {t('Select traders to send request')}
                      </Typography>
                    </Stack>
                  </Stack>
                </PageHeader>
                <Datatable
                  tableHeadBgColor={'rgb(243 244 247)'}
                  columns={columns}
                  data={tradeList || []}
                  isLoading={isloading}
                  showCheckBox={true}
                  onChangeCheckBox={handleOnChangeCheckBox}
                  onAllSelectCheckBox={(checkedStatus) => {
                    const arr = tradeList.map((res) => {
                      return {
                        ...res,
                        isSelected: checkedStatus,
                      };
                    });
                    setSelectedCompanyIds(checkedStatus ? arr : []);
                  }}
                  isAllChecked={isAllChecked}
                />
              </Stack>
              <Stack
                direction="row"
                justifyContent="flex-end"
                className="px-4 py-2 !justify-end p-[0px] sticky bottom-[0] !mt-[32px]"
                // className="!mt-[44px] h-[66px] "
                style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                        // borderColor: theme.palette.secondary.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                  onClick={() => {
                    onModelHandleClose(false);
                  }}
                >
                  {t('Close')}
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: theme.palette.background.main,
                      backgroundColor: theme.palette.primary.dark,
                      textTransform: 'uppercase',
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', height: '40px' }}
                  disabled={!(dirty && isValid) || selectedCompanyIds.length === 0}
                  type="submit"
                  variant="contained"
                >
                  {t(`Send`)}
                </Button>
              </Stack>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
